import React, { useState } from 'react';
import styles from './RequestsTable.module.css';

import ArrowsSvg from '@icons/Arrows.svg';
import SortUpSvg from '@icons/SortUp.svg';
import SortDownSvg from '@icons/SortDown.svg';

import {Loader, Table} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Modal } from '@mantine/core';
import ModalForm from './ModalForm';
import { useTranslation } from 'react-i18next';

const RequestsTable = ({ sortName, sortValue, fetchClaims, claims, sort, fetchClaim, updateClaim, isLoading }) => {
  const { t } = useTranslation();
  const [claim, setClaim] = useState(null);
  const [opened, { open, close }] = useDisclosure(false);

  const statuses = {
    RECALLED: {
      color: 'orange',
      text: t('statuses.claims.recalled')
    },
    ON_REVIEW: {
      color: '#3A86FF',
      text: t('statuses.claims.onreview')
    },
    APPROVED: {
      color: '#68BF61',
      text: t('statuses.claims.approved')
    },
    PUBLISHED: {
      color: '#68BF61',
      text: t('statuses.published')
    },
    REJECTED: {
      color: '#FF5959',
      text: t('statuses.claims.rejected')
    },
    INFORMATION_REQUIRED: {
      color: '#0091b3',
      text: t('statuses.claims.information_required')
    }
  }

  const handleClick = (data) => {
    setClaim(data)
    open()
  }

  const getIcon = (name) => {
    if (sortName !== name) {
      return ArrowsSvg;
    }

    if (sortValue === -1) {
      return SortUpSvg
    } else {
      return SortDownSvg;
    }
  }

  const showDate = (value) => {
    const myDate = new Date(value);
    let m = myDate.getMonth() + 1;
    let d = myDate.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;

    return `${d}.${m}.${myDate.getFullYear()}`;
  }

  const rows = claims.map((element, index) => (
    <Table.Tr key={`${element.id}${index}`} className={styles.bodyTr} onClick={() => handleClick(element)}>
      <Table.Td className={styles.nameTh}>{element.id}</Table.Td>

      <Table.Td className={styles.dateTh}>{showDate(element.created)}</Table.Td>

      <Table.Td className={styles.addressTh}>{element.organizationName}</Table.Td>

      <Table.Td className={styles.addressTh}>{element.placeName}</Table.Td>

      <Table.Td
        className={styles.statusTh}
        style={{ color: statuses[element.status]?.color }}
      >
        {statuses[element.status]?.text}
      </Table.Td>
    </Table.Tr>
  ));

  return isLoading ? (
      <div className={styles.loader}>
        <Loader/>
      </div>
  ) : (
      <div className={styles.wrapper}>
    <Table stickyHeader stickyHeaderOffset={0}>
      <Table.Thead className={styles.thead}>
        <Table.Tr className={styles.headTr}>
          <Table.Th className={styles.headTh}>
            <div className={styles.contentName}>
              {t('requests.table.header1')}

              <div className={styles.sort}>
                <img src={getIcon('id')} onClick={() => sort('id')} />
              </div>
            </div>
          </Table.Th>
          <Table.Th className={styles.headTh}>
            <div className={styles.contentName}>
              {t('requests.table.header2')}
              <div className={styles.sort}>
                <img src={getIcon('date')} onClick={() => sort('date')} />
              </div>
            </div>
          </Table.Th>
          <Table.Th className={styles.headTh}>
            <div className={styles.contentName}>
              {t('requests.table.header3')}

              <div className={styles.sort}>
                <img src={getIcon('organizationName')} onClick={() => sort('organizationName')} />
              </div>
            </div>
          </Table.Th>
          <Table.Th className={styles.headTh}>
            <div className={styles.contentName}>
              {t('requests.table.header4')}

              <div className={styles.sort}>
                <img src={getIcon('place')} onClick={() => sort('place')} />
              </div>
            </div>
          </Table.Th>
          <Table.Th className={styles.headTh}>
            <div className={styles.contentName}>
              {t('requests.table.header5')}

              <div className={styles.sort}>
                <img src={getIcon('status')} onClick={() => sort('status')} />
              </div>
            </div>
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>

      <Modal
        opened={opened}
        style={{ width: '471px' }}
        size={471}
        onClose={close}
        removeScrollProps
        centered
        title={false}
        className={styles.modal}
      >
        <ModalForm
          onClose={close}
          fetchClaims={fetchClaims}
          claim={claim}
          updateClaim={updateClaim}
          fetchClaim={fetchClaim}
        />
      </Modal>
    </Table>
      </div>
  )
}

export default RequestsTable;
